module.exports = __webpack_public_path__ + "img/public/AdminIcons/staticContentIcon.svg?9d374dbd";